export default __webpack_public_path__ + "static/media/plane.ae296c85.glb";